/**
 * Legacy fetch-based request helper. Used heavily by Redux middleware in `src/store/middleware/`.
 * Prefer `src/utils/api-calls/index.ts` (axios) for new code.
 */
export const request = (
  apiUrl: string,
  jwt: string | null = null,
  method: string = "GET",
  body?: unknown
): Promise<Response | unknown> => {
  return new Promise((resolve, reject) => {
    const payload: RequestInit = {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    };
    if (body) {
      payload.body = JSON.stringify(body);
    }

    return fetch(apiUrl, payload)
      .then(
        (response: Response) => {
          if (response.ok) {
            switch (response.status) {
              case 202:
                resolve(response);
                return;
              case 204:
                resolve(response);
                return;
              default:
                resolve(response.json());
                return;
            }
          }
          reject(response);
        },
        (error: unknown) => {
          reject(error instanceof Error ? error : new Error(String(error)));
        }
      )
      .catch((error: unknown) =>
        reject(error instanceof Error ? error : new Error(String(error)))
      );
  });
};

/**
 * Legacy fetch-based image upload helper. FormData body, not JSON-serialized.
 */
export const postImage = (
  apiUrl: string,
  jwt: string | null = null,
  method: string = "GET",
  body: FormData | null = null
): Promise<Response | unknown> => {
  return new Promise((resolve, reject) => {
    return fetch(apiUrl, {
      method,
      credentials: "same-origin",
      headers: {
        Authorization: `Bearer ${jwt}`,
        Accept:
          "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
      },
      body,
    } as RequestInit).then(
      (response: Response) => {
        if (response.ok) {
          switch (response.status) {
            case 204:
              resolve(response);
              return;
            case 200:
              resolve(response.json());
              return;
            case 404:
              reject();
              return;
            default:
              resolve(response);
              return;
          }
        }
        switch (response.status) {
          case 500:
          case 400:
          case 422:
            resolve(response);
            return;
          default:
            reject(response);
        }
      },
      (error: unknown) => {
        reject(error instanceof Error ? error : new Error(String(error)));
      }
    );
  });
};
